import { getAnalytics } from '..';
import { StickyPlacement, Widget } from '../../enums';
import {
  StoryPreviewAnimation,
  StoryPreviewDisplay,
} from '../../pimster-story-preview/pimster-story-preview.constants';
import { EVENTS } from '../constants';

export type CloseEventPayload = {
  widgetType: Widget.StickyStory;
  company: string;
  product: string;
  storyId: string;
  display: StoryPreviewDisplay;
  placement: StickyPlacement;
  animations: StoryPreviewAnimation[];
};

export const trackClose = (payload: CloseEventPayload) => {
  const analytics = getAnalytics();
  analytics?.track(EVENTS.Close, payload);
};
